<template>
  <div class="">
      <div>
        <el-row :gutter="20">
          <el-col>
            <el-switch
              v-model="switchFlag"
              active-color="#13ce66"
              inactive-text="自动刷新"
              @change="changeTimer">
            </el-switch>
            <!-- <el-button type="primary" @click="startTimer">自动刷新</el-button>
            <el-button type="primary" @click="stopTimer">关闭</el-button> -->
          </el-col>
        </el-row>
      </div>
       <el-row >
       <div style="margin-bottom: 10px; margin-top: 20px;">
         待分配订单
       </div>
       <el-table
        :data="toAllocatedOrderList"
        border
        height="400"
        stripe
        style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            width="50">
          </el-table-column>
           <el-table-column
            prop="merchantName"
            header-align="center"
            label="商户">
          </el-table-column>
          <el-table-column
            prop="orderNo"
            header-align="center"
            label="订单编号">
          </el-table-column>
          <el-table-column
            prop="clerkSkuName"
            header-align="center"
            label="sku名称">
          </el-table-column>
          <el-table-column
            prop="originSystemQuote"
            header-align="center"
            label="订单价格">
          </el-table-column>
          <el-table-column
            prop="sendType"
            header-align="center"
            label="发送对象">
            <template slot-scope="scope">
              <span v-if="scope.row.sendType === 0">报价员</span>
              <span v-else>机器人</span>
            </template>
          </el-table-column>
           <el-table-column
            prop="createTime"
            header-align="center"
            label="创建时间">
          </el-table-column>
           <el-table-column
            prop="expireTime"
            header-align="center"
            label="有效时间">
          </el-table-column>
           <el-table-column
            prop="selfOrderFlag"
            header-align="center"
            label="是否自有订单">
             <template slot-scope="scope">
            <span v-if="scope.row.selfOrderFlag === 0">是</span>
            <span v-else>否</span>
          </template>
          </el-table-column>
      </el-table>
       </el-row>
    <el-row :gutter="20" style="margin-top: 20px;">
      <el-col style="width: 50%;">
         <div style="margin-bottom: 10px;">
         在线报价员
       </div>
       <el-table
        :data="receiveOrderUserNameList"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="realName"
            header-align="center"
            label="姓名">
          </el-table-column>
      </el-table>
      </el-col>
      <el-col style="width: 50%;">
         <div style="margin-bottom: 10px;">
         正在报价报价员
       </div>
       <el-table
        :data="quotingUserNameList"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="realName"
            header-align="center"
            label="姓名">
          </el-table-column>
            <el-table-column header-align="center"
            label="操作">
              <template slot-scope="scope">
                <el-button @click="clearQuoteLock(scope.row.id)" type="text" size="small" style="color: gray;">清除锁</el-button>
              </template>
          </el-table-column>
      </el-table>
        </el-col>
    </el-row>
    
  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      quotingUserNameList:[],
      receiveOrderUserNameList:[],
      toAllocatedOrderList:[],
      switchFlag: false,
    }
  },
  watch:{},
  computed:{},
  methods:{
    changeTimer(){
      if(this.switchFlag){
         this.startTimer()
      }else{
         this.stopTimer()
      }
    },
     // 获取门店列表
    getToAllocatedOrderList() {
      let self  = this;
      self.$api.getToAllocatedOrderList().then(res => {
        self.toAllocatedOrderList = res.data || []
      })
    },
      // 获取门店列表
    getReceiveOrderUserNameList() {
      let self  = this;
      self.$api.getReceiveOrderUserNameList().then(res => {
        self.receiveOrderUserNameList = res.data || []
      })
    },
      // 获取门店列表
    getQuotingUserNameList() {
      let self  = this;
      self.$api.getQuotingUserNameList().then(res => {
        self.quotingUserNameList = res.data || []
      })
    },
    //清理派单锁
    clearQuoteLock(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.clearQuoteLock({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '清除成功',
              type: 'success'
            });
             this.getQuotingUserNameList()
          }
      })
      })
    },

    toAllocatedOrderstartTimerMethod() {
      // 避免重复创建定时器
      let self = this;
      if (self.toAllocatedOrderTimer) return;
      // 创建定时器，每秒执行一次
      self.toAllocatedOrderTimer = setInterval(() => {
        self.getToAllocatedOrderList();
      }, 2000);
    },

     quotingStartTimerMethod() {
      let self = this;
      // 避免重复创建定时器
      if (self.quotingStartTimer) return;
      // 创建定时器，每秒执行一次
      self.quotingStartTimer = setInterval(() => {
        self.getQuotingUserNameList();
      }, 3000);
    },

     receiveOrderStartTimerMethod() {
      let self = this;
      // 避免重复创建定时器
      if (self.receiveOrderStartTimer) return;
      
      // 创建定时器，每秒执行一次
      self.receiveOrderStartTimer = setInterval(() => {
        self.getReceiveOrderUserNameList();
      }, 30000);
    },
     startTimer(){
        this.toAllocatedOrderstartTimerMethod()
        this.quotingStartTimerMethod()
        this.receiveOrderStartTimerMethod()
     },
     stopTimer() {
      // 清除定时器
      if (this.receiveOrderStartTimer) {
        clearInterval(this.receiveOrderStartTimer);
        this.receiveOrderStartTimer = null;
      }
       // 清除定时器
      if (this.quotingStartTimer) {
        clearInterval(this.quotingStartTimer);
        this.quotingStartTimer = null;
      }
       // 清除定时器
      if (this.toAllocatedOrderTimer) {
        clearInterval(this.toAllocatedOrderTimer);
        this.toAllocatedOrderTimer = null;
      }
    },

  },
  beforeDestroy() {
    console.log("销毁定时任务")
    // 组件销毁前清除定时器，避免内存泄漏
     this.stopTimer();
  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getToAllocatedOrderList();
    self.getQuotingUserNameList();
    self.getReceiveOrderUserNameList();
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>